export default __webpack_public_path__ + "static/top-c565f935130aaddc48c4ba928627eb23.png";